/**
 * Rich errors + logging for HPXML ↔ Volta audit debugging.
 */

/**
 * @param {unknown} err
 * @param {{ phase?: string, rowId?: string }} context
 * @returns {{ phase?: string, rowId?: string, message: string, stack: string, causeMessage?: string, causeStack?: string }}
 */
export function makeAuditError(err, context = {}) {
    const base = err instanceof Error ? err : new Error(String(err));
    const ctx = base.auditContext || {};
    const phase = context.phase ?? ctx.phase ?? "unknown";
    const rowId = context.rowId ?? ctx.rowId;
    const cause = base.cause instanceof Error ? base.cause : null;

    return {
        phase,
        rowId,
        message: base.message,
        stack: typeof base.stack === "string" ? base.stack : "",
        causeMessage: cause?.message,
        causeStack: typeof cause?.stack === "string" ? cause.stack : undefined,
    };
}

/**
 * @param {ReturnType<typeof makeAuditError>} payload
 */
export function logAuditFailure(payload) {
    const parts = ["[HPXML audit] failed"];
    if (payload.phase) parts.push(`phase=${payload.phase}`);
    if (payload.rowId) parts.push(`rowId=${payload.rowId}`);
    console.error(parts.join(" | "), "\nMessage:", payload.message);
    if (payload.stack) {
        console.error("Stack:\n", payload.stack);
    }
    if (payload.causeMessage || payload.causeStack) {
        console.error("Caused by:", payload.causeMessage || "(no message)");
        if (payload.causeStack) {
            console.error("Cause stack:\n", payload.causeStack);
        }
    }
}
